import { render, staticRenderFns } from "./CharactersRight.vue?vue&type=template&id=f4c23e8e&scoped=true&"
import script from "./CharactersRight.vue?vue&type=script&lang=js&"
export * from "./CharactersRight.vue?vue&type=script&lang=js&"
import style0 from "./CharactersRight.vue?vue&type=style&index=0&id=f4c23e8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c23e8e",
  null
  
)

export default component.exports